export default __webpack_public_path__ + "static/media/WB-graph-app-cover.e8956c7c.png";